import React, { useState, useEffect } from 'react';
import axios from 'axios';
import toast from './utils/Toast';
import Loader from './utils/Loader';
import Navbar from './utils/Navbr';
import './style/ManagePublishers.css';
import { useNavigate } from 'react-router-dom';

const ManagePublishers = () => {
    // --- State ---
    const [loading, setLoading] = useState(true);
    const [loader, setLoader] = useState(true);
    const [publishers, setPublishers] = useState([]);
    const [filteredPubs, setFilteredPubs] = useState([]);
    const [search, setSearch] = useState('');
    const navigate = useNavigate(); 
    // Pending Requests State
    const [pendingModalOpen, setPendingModalOpen] = useState(false);
    const [pendingList, setPendingList] = useState([]);
    const [selectedPending, setSelectedPending] = useState([]);

    // Details Modal State
    const [detailsModalOpen, setDetailsModalOpen] = useState(false);
    const [currentPub, setCurrentPub] = useState(null);

    const getCookie = (name) => {
        const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
        return match ? decodeURIComponent(match[1]) : null;
    };

    // --- FETCH DATA ---
    const fetchPublishers = async () => {
        setLoading(true);
        const adminToken = getCookie('adminToken');
        try {
            const response = await axios.post('https://publisher.cashbolt.in.net/server/', {
                action: 'fetchPublishers',
                adminToken: adminToken
            });
            if (response.data.status === true) {
                setPublishers(response.data.data);
                setFilteredPubs(response.data.data);
            }
        } catch (error) {
        } finally {
            setLoading(false);
        }
    };

    const fetchPending = async () => {
        try {
            const response = await axios.post('https://publisher.cashbolt.in.net/server/', {
                action: 'fetchPendingPublishers',
                adminToken: getCookie('adminToken') || 'demo_token'
            });
            if (response.data.status === true) setPendingList(response.data.data);
            else setPendingList(pendingList);
        } catch (e) { setPendingList(pendingList); }
    };

    useEffect(() => {
                const adminToken = getCookie('adminToken');

        const init = async () => {
            try {
                // ✅ 1. Admin Auth Check
                const authRes = await axios.post('https://publisher.cashbolt.in.net/server/', {
                    action: 'checkAuthAdmin',
                    adminToken
                });

                if (!authRes.data.status) {
                    toast.error(authRes.data.message || 'Admin session expired');
                    navigate('/cbMediaAdmin7/login');
                    return;
                }

                fetchPublishers();

            } catch (err) {
                toast.error('Admin auth check failed');
                navigate('/cbMediaAdmin7/login');
            } finally {
                setLoader(false);
            }
        };
        init();
    }, []);

    // --- Search Logic ---
    useEffect(() => {
        if (!search) {
            setFilteredPubs(publishers);
        } else {
            const lowerSearch = search.toLowerCase();
            const filtered = publishers.filter(p =>
                p.name.toLowerCase().includes(lowerSearch) ||
                p.id.toLowerCase().includes(lowerSearch)
            );
            setFilteredPubs(filtered);
        }
    }, [search, publishers]);

    // --- Actions ---
    const handleViewDetails = (pub) => {
        setCurrentPub(pub);
        setDetailsModalOpen(true);
    };

const handleBan = async (id, currentStatus) => {
    const action = currentStatus === 'banned' ? 'unban' : 'ban';
    if (window.confirm(`Are you sure you want to ${action} this publisher?`)) {

        try {
            const res = await axios.post('https://publisher.cashbolt.in.net/server/', {
                action: action === 'ban' ? 'adminBanPublisher' : 'adminUnbanPublisher',
                adminToken: getCookie('adminToken'),
                pubId: id
            });

            if (res.data.status) {
                toast.success(`Publisher ${action}ned successfully`);
                setPublishers(prev =>
                    prev.map(p => p.id === id
                        ? { ...p, status: action === 'ban' ? 'banned' : 'active' }
                        : p
                    )
                );
            } else {
                toast.error(res.data.message || "Action failed");
            }
        } catch (e) {
            toast.error("Server Error");
        }
    }
};

const handleDelete = async (id) => {
    if (window.confirm("Delete this publisher? This action cannot be undone.")) {

        try {
            const res = await axios.post('https://publisher.cashbolt.in.net/server/', {
                action: 'adminDeletePublisher',
                adminToken: getCookie('adminToken'),
                pubId: id
            });

            if (res.data.status) {
                toast.success("Publisher deleted");
                setPublishers(prev => prev.filter(p => p.id !== id));
            } else {
                toast.error(res.data.message || "Delete Failed");
            }
        } catch (e) {
            toast.error("Server Error");
        }
    }
};

// --- Pending / Bulk Logic ---
const togglePendingRow = (id) => {
    setSelectedPending(prev =>
        prev.includes(id) ? prev.filter(item => item !== id) : [...prev, id]
    );
};

const toggleAllPending = () => {
    if (selectedPending.length === pendingList.length) {
        setSelectedPending([]);
    } else {
        setSelectedPending(pendingList.map(p => p.id));
    }
};

const handleBulkAction = async (type) => {
    if (selectedPending.length === 0) return toast.warning("No rows selected");

    try {
        const res = await axios.post('https://publisher.cashbolt.in.net/server/', {
            action: type === 'approve' ? 'adminBulkApprovePublishers' : 'adminBulkRejectPublishers',
            adminToken: getCookie('adminToken'),
            pubIds: selectedPending
        });

        if (res.data.status) {
            toast.success(`${selectedPending.length} Requests ${type === 'approve' ? 'Approved' : 'Rejected'}`);
            setPendingList(prev => prev.filter(p => !selectedPending.includes(p.id)));
            setSelectedPending([]);
        } else {
            toast.error(res.data.message || "Bulk action failed");
        }
    } catch (e) {
        toast.error("Server Error");
    }
};

    const openPendingModal = () => {
        fetchPending();
        setPendingModalOpen(true);
    };
    if (loader) return <Loader />;
    return (
        <div className="mp-wrapper_mp">
            <Navbar role="Administrator" isAdmin={true} />

            <div className="bg-shape_mp shape-1_mp"></div>
            <div className="bg-shape_mp shape-2_mp"></div>

            <div className="mp-content_mp">

                <div className="mp-header_mp">
                    <div className="header-left_mp">
                        <h2>Manage <span className="highlight_mp">Publishers</span></h2>
                        <p>Monitor users, earnings, and approval requests</p>
                    </div>

                    <button className="pending-btn_mp" onClick={openPendingModal}>
                        <span className="bell-icon_mp">🔔</span>
                        Pending Requests
                        <div className="wave_mp"></div>
                    </button>
                </div>

                {/* --- Search & Controls --- */}
                <div className="controls-bar_mp">
                    <div className="search-box_mp">
                        <input
                            type="text"
                            placeholder="Search by Publisher Name or ID..."
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                        />
                        <button className="search-icon-btn_mp">🔍</button>
                    </div>
                </div>

                {/* --- Publishers Table --- */}
                <div className="table-card_mp">
                    {loading ? <div className="loader-container_perf"><div className="spinner_perf"></div><p>Loading Data...</p></div> : (
                        <div className="table-scroll_mp">
                            <table className="mp-table_mp">
                                <thead>
                                    <tr>
                                        <th>Pub ID</th>
                                        <th>Name</th>
                                        <th className="text-center_mp">Balance</th>
                                        <th className="text-center_mp">Clicks</th>
                                        <th className="text-center_mp">Conv.</th>
                                        <th className="text-right_mp">Earned</th>
                                        <th className="text-right_mp">Withdraw</th>
                                        <th className="text-right_mp">Revenue</th>
                                        <th className="text-center_mp">Status</th>
                                        <th className="text-center_mp sticky-col_mp">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredPubs.map(pub => (
                                        <tr key={pub.id} className={`table-row_mp ${pub.status === 'banned' ? 'banned-row_mp' : ''}`}>
                                            <td className="mono_mp">{pub.id}</td>
                                            <td className="name-cell_mp">
                                                <div className="avatar_mp">{pub.name.charAt(0)}</div>
                                                <div className="user-info_mp">
                                                    <span>{pub.name}</span>
                                                    <small>{pub.email}</small>
                                                </div>
                                            </td>
                                            <td className="text-center_mp font-bold_mp">₹{pub.balance}</td>
                                            <td className="text-center_mp">{pub.clicks}</td>
                                            <td className="text-center_mp success-text_mp">{pub.conversions}</td>
                                            <td className="text-right_mp earn-text_mp">₹{pub.earned}</td>
                                            <td className="text-right_mp">₹{pub.withdraw}</td>
                                            <td className="text-right_mp font-bold_mp">₹{pub.revenue}</td>
                                            <td className="text-center_mp">
                                                <span className={`status-badge_mp ${pub.status}`}>{pub.status}</span>
                                            </td>
                                            <td className="sticky-col_mp actions-cell_mp">
                                                <button className="icon-btn_mp blue" title="Details" onClick={() => handleViewDetails(pub)}>👁️</button>
                                                <button
                                                    className={`icon-btn_mp ${pub.status === 'banned' ? 'green' : 'orange'}`}
                                                    title={pub.status === 'banned' ? 'Unban' : 'Ban'}
                                                    onClick={() => handleBan(pub.id, pub.status)}
                                                >
                                                    {pub.status === 'banned' ? '🔓' : '🚫'}
                                                </button>
                                                <button className="icon-btn_mp red" title="Delete" onClick={() => handleDelete(pub.id)}>🗑️</button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>

            </div>

            {/* --- REDESIGNED DETAILS MODAL --- */}
            {detailsModalOpen && currentPub && (
                <div className="modal-overlay_mp" onClick={() => setDetailsModalOpen(false)}>
                    <div className="modal-content_mp details-modal_mp" onClick={e => e.stopPropagation()}>

                        {/* Header Profile Section */}
                        <div className="details-header-section_mp">
                            <button className="close-abs_mp" onClick={() => setDetailsModalOpen(false)}>&times;</button>
                            <div className="large-avatar_mp">{currentPub.name.charAt(0)}</div>
                            <div className="profile-info-center_mp">
                                <h3>{currentPub.name}</h3>
                                <span className="id-pill_mp">{currentPub.id}</span>
                            </div>
                        </div>

                        {/* Details Grid */}
                        <div className="details-body-section_mp">
                            <h4 className="section-title_mp">Account Information</h4>
                            <div className="info-grid_mp">

                                <div className="info-card_mp">
                                    <div className="info-icon_mp">📧</div>
                                    <div className="info-content_mp">
                                        <label>Email Address</label>
                                        <p>{currentPub.email}</p>
                                    </div>
                                </div>

                                <div className="info-card_mp">
                                    <div className="info-icon_mp">📞</div>
                                    <div className="info-content_mp">
                                        <label>Phone Number</label>
                                        <p>{currentPub.details.phone}</p>
                                    </div>
                                </div>

                                <div className="info-card_mp">
                                    <div className="info-icon_mp">✈️</div>
                                    <div className="info-content_mp">
                                        <label>Telegram ID</label>
                                        <a href={`https://t.me/${currentPub.details.telegram.replace('@', '')}`} target="_blank" rel="noreferrer" className="link-text_mp">
                                            {currentPub.details.telegram}
                                        </a>
                                    </div>
                                </div>

                                <div className="info-card_mp">
                                    <div className="info-icon_mp">🔒</div>
                                    <div className="info-content_mp">
                                        <label>Password</label>
                                        <div className="password-reveal_mp">
                                            <span>{currentPub.details.pass}</span>
                                        </div>
                                    </div>
                                </div>

                                <div className="info-card_mp">
                                    <div className="info-icon_mp">🛡️</div>
                                    <div className="info-content_mp">
                                        <label>Role</label>
                                        <p>{currentPub.details.role}</p>
                                    </div>
                                </div>

                                <div className="info-card_mp">
                                    <div className="info-icon_mp">📋</div>
                                    <div className="info-content_mp">
                                        <label>KYC Status</label>
                                        <span className={`kyc-tag_mp ${currentPub.details.kyc.toLowerCase()}`}>
                                            {currentPub.details.kyc === 'Verified' ? '✓ Verified' : '⚠ Pending'}
                                        </span>
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            )}

            {/* --- PENDING REQUESTS MODAL --- */}
            {pendingModalOpen && (
                <div className="modal-overlay_mp" onClick={() => setPendingModalOpen(false)}>
                    <div className="modal-content_mp pending-modal_mp" onClick={e => e.stopPropagation()}>
                        <div className="modal-header_mp">
                            <h3>Pending Requests <span className="count-badge_mp">{pendingList.length}</span></h3>
                            <button className="close-btn_mp" onClick={() => setPendingModalOpen(false)}>&times;</button>
                        </div>

                        <div className="modal-body_mp no-padding_mp">
                            {selectedPending.length > 0 && (
                                <div className="bulk-bar_mp">
                                    <span>{selectedPending.length} Selected</span>
                                    <div className="bulk-btns_mp">
                                        <button className="bulk-act_mp approve" onClick={() => handleBulkAction('approve')}>Approve All</button>
                                        <button className="bulk-act_mp reject" onClick={() => handleBulkAction('reject')}>Reject All</button>
                                    </div>
                                </div>
                            )}

                            <div className="pending-table-wrapper_mp">
                                <table className="pending-table_mp">
                                    <thead>
                                        <tr>
                                            <th>
                                                <input
                                                    type="checkbox"
                                                    className="custom-check_mp"
                                                    checked={selectedPending.length === pendingList.length && pendingList.length > 0}
                                                    onChange={toggleAllPending}
                                                />
                                            </th>
                                            <th>Name</th>
                                            <th>Contact</th>
                                            <th>Company</th>
                                            <th>Traffic</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {pendingList.map(req => (
                                            <tr key={req.id} className={selectedPending.includes(req.id) ? 'selected-row_mp' : ''}>
                                                <td>
                                                    <input
                                                        type="checkbox"
                                                        className="custom-check_mp"
                                                        checked={selectedPending.includes(req.id)}
                                                        onChange={() => togglePendingRow(req.id)}
                                                    />
                                                </td>
                                                <td className="font-bold_mp">{req.name}</td>
                                                <td className="small-text_mp">
                                                    <div>{req.email}</div>
                                                    <div>{req.phone}</div>
                                                </td>
                                                <td>{req.company}</td>
                                                <td><span className="source-tag_mp">{req.source}</span></td>
                                                <td>
                                                    <div className="mini-actions_mp">
                                                        <button className="mini-btn_mp tick" onClick={() => { toast.success("Approved"); setPendingList(l => l.filter(i => i.id !== req.id)) }}>✓</button>
                                                        <button className="mini-btn_mp cross" onClick={() => { toast.error("Rejected"); setPendingList(l => l.filter(i => i.id !== req.id)) }}>✕</button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                        {pendingList.length === 0 && <tr><td colSpan="6" className="no-req_mp">No pending requests</td></tr>}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            )}

        </div>
    );
};

export default ManagePublishers;